import { render } from "./ProdutoRepeticao.vue?vue&type=template&id=bf16cf50&scoped=true"
import script from "./ProdutoRepeticao.vue?vue&type=script&lang=js"
export * from "./ProdutoRepeticao.vue?vue&type=script&lang=js"

import "./ProdutoRepeticao.vue?vue&type=style&index=0&id=bf16cf50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf16cf50"]])

export default __exports__